import React from 'react';
import { Steps } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';

interface ProgressProps {
  currentStage: number;
  onStepClick: (step: number) => void;
}

const STAGE_ROUTES: Record<string, string> = {
  'individual-1': '/review-hub/pm/individual',
  'individual-2': '/review-hub/level1/individual',
  'individual-3': '/review-hub/level2/individual',
  'individual-4': '/review-hub/stack/individual',
  'team-1':       '/review-hub/pm/team',
  'team-2':       '/review-hub/level1/team',
  'team-3':       '/review-hub/level2/team',
};

const Progress: React.FC<ProgressProps> = ({ currentStage, onStepClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isTeam = location.pathname.includes('team');
  const type = isTeam ? 'team' : 'individual';

  const handleStepClick = (stepIndex: number) => {
    const route = STAGE_ROUTES[`${type}-${stepIndex}`];
    if (route) navigate(route);
    else onStepClick(stepIndex);
  };

  const steps = [
    { title: 'Nominated',        date: 'Jun 22 – Jul 3, 2026' },
    { title: 'Manager Review',   date: 'Jul 10, 2026' },
    { title: 'Unit Head Review', date: 'Jul 14, 2026' },
    { title: 'ELT Review',       date: 'Jul 17, 2026' },
    { title: 'ELT Calibration',  date: 'Jul 27, 2026' },
    { title: 'Final Review',     date: 'Jul 28, 2026' },
  ];

  return (
    <Steps
      size="small"
      current={currentStage}
      style={{ padding: '8px 0' }}
      items={steps.map((s, i) => ({
        title: (
          <span
            onClick={() => handleStepClick(i)}
            style={{
              cursor: i < currentStage ? 'pointer' : 'default',
              color: i === currentStage ? '#481558' : i < currentStage ? '#52c41a' : '#bfbfbf',
              fontWeight: i === currentStage ? 600 : 400,
              fontSize: 12,
            }}
          >
            {s.title}
          </span>
        ),
        description: s.date ? (
          <span style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 3,
            marginTop: 3,
            padding: '2px 6px',
            borderRadius: 10,
            fontSize: 10,
            fontWeight: 500,
            whiteSpace: 'nowrap',
            background: i < currentStage ? '#f6ffed' : i === currentStage ? '#f3e8ff' : '#f5f5f5',
            color:      i < currentStage ? '#389e0d'  : i === currentStage ? '#481558'  : '#8c8c8c',
            border: `1px solid ${i < currentStage ? '#b7eb8f' : i === currentStage ? '#d3adf7' : '#e8e8e8'}`,
          }}>
            <CalendarOutlined style={{ fontSize: 9 }} />
            {s.date}
          </span>
        ) : undefined,
      }))}
    />
  );
};

export default Progress;
